import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import MenuInterface, { MenuKeys } from 'modules/shared/layout/menu/interfaces/menu.interface';
import Icon from 'atomic/icon';
import SubMenuItem from 'modules/shared/layout/menu/menu-desktop/components/department-menu/components/sub-menu/components/sub-menu-item';
import Recommended from 'modules/shared/layout/menu/components/recommended/recommended';
import MenuBanner from 'modules/shared/layout/menu/components/menu-banner';

import './sub-menu.scss';

interface SubMenuProps {
    item: MenuInterface | null;
    onMouseLeave: () => void;
    onMouseEnter: () => void;
    topPosition: number;
}

const SubMenu: React.FC<SubMenuProps> = ({
    onMouseLeave,
    onMouseEnter,
    item,
    topPosition
}): ReactElement | null => {
    if (!item) {
        return null;
    }

    const showRightSlot = Boolean(item[MenuKeys.recommended]?.length) || Boolean(item[MenuKeys.banner]?.length);

    return ReactDOM.createPortal(
        <div
            id="sub-menu"
            className="sub-menu"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            style={{ height: `calc(100vh - ${topPosition}px)`, top: `${topPosition}px` }}
        >
            <div className="sub-menu__header">
                <div className="sub-menu__header__content">
                    <span className="name">{item[MenuKeys.name]}</span>
                    <a className="link" href={item.url}>
                        Wszystkie produkty
                        <Icon name="arrow-right" size={20} color="primary" />
                    </a>
                </div>
            </div>
            <div className="sub-menu__container">
                {Boolean(item[MenuKeys.items]?.length) && (
                    <SubMenuItem items={item[MenuKeys.items] || []} showRightSlot={showRightSlot} />
                )}
                {(showRightSlot) && (
                    <div className="sub-menu__container__right">
                        {Boolean(item[MenuKeys.recommended]?.length) && (
                            <Recommended recommendedItems={item[MenuKeys.recommended]} />
                        )}
                        {Boolean(item[MenuKeys.banner]?.length) && (
                            <MenuBanner bannerItems={item[MenuKeys.banner] || []} />
                        )}
                    </div>
                )}
            </div>
        </div>,
        document.body
    );
};

export default SubMenu;
